import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import { SetupRequestService } from "@/services/setup/SetupRequestService";
import type { SetupRequestPayload } from "@/types/setup/request";

/** Send a completed setup request to the team (drops into #onboarding). */
export const useSubmitSetupRequest = () =>
  useMutation({
    mutationFn: (payload: SetupRequestPayload) => SetupRequestService.submit(payload),
    onError: (error: Error) => {
      toast.error(error.message || "We couldn't send your details. Please try again.");
    },
  });
